export default {"src":"/_next/static/image/public/images/flags/flag_354.1daa194a99cb3b90b425255ed92a5922.svg","height":16,"width":24};